import React from 'react';
import { UserProfile } from 'src/components/user-profile';

const UserProfilePage = () => {
  return <UserProfile />;
};

export { UserProfilePage };
